export default __webpack_public_path__ + "static/media/login-cover.f3995624.png";